









































import { Vue, Component } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import list, { ConditionsListParams } from "@/getinfo-api/conditions";
import { getCurrentCompanyId } from "@/plugins/roles";
import { agentApi } from "@/getinfo-api";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import ConditionTable from "@/components/condition/ConditionTable.vue";
import { Condition as ICondition } from "@/api-v2/agent/models/condition";

@Component({
  components: { ConditionTable, CBlock, CPage }
})
export default class ConditionList extends Vue {
  conditions: ICondition[] = [];
  count: number = 0;
  isLoading: boolean = false;
  title?: string = "";
  isPercent?: boolean;
  offset: number = 0;

  data() {
    return {
      isPercent: undefined
    };
  }

  get companyId() {
    return getCurrentCompanyId();
  }

  applyFilterHandler() {
    this.count = 0;
    this.offset = 0;
    this.conditions = [];
    this.getConditions();
  }

  clearFilterHandler() {
    this.count = 0;
    this.conditions = [];
    this.offset = 0;
    this.title = undefined;
    this.isPercent = undefined;
    this.getConditions();
  }

  showMoreHandler() {
    this.offset += 30;
    this.getConditions(this.offset);
  }

  async removeHandler(condition: ICondition) {
    try {
      this.isLoading = true;
      const response = await agentApi.Condition.deleteCondition(condition.id!);
      if (response.status === 200 || response.status === 204) {
        this.conditions = this.conditions?.filter(el => el.id !== condition.id);
        this.count = this.count - 1;
      }
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  async getConditions(offset: number = 0) {
    const params: ConditionsListParams = {
      companyId: this.companyId,
      ids: undefined,
      percent: this.isPercent,
      title: this.title?.length ? this.title : undefined,
      limit: 30,
      offset: offset,
      sort: "updatedAt",
      order: "DESC"
    };

    try {
      this.isLoading = true;
      const { data } = await list(params);
      this.conditions = [...this.conditions, ...data.items];
      this.count = data.count;
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  created() {
    this.getConditions();
  }
}
